import React from 'react';
import '../../../css/buttons/SecondaryButton.css';

const SecondaryButton = ({ onClick, text }) => {
  return (
    <button className="secondary-button" onClick={onClick}>
      <div className="nav-bold primary">{text}</div>
    </button>
  );
}

export default SecondaryButton;